import { AiUserFeedbackParams } from '@panaya/ui/p-ai-feedback';
import { HttpClient, HttpContext } from '@angular/common/http';
import { IGNORE_CLIENT_LOADING } from '@frontend-site/shared/core';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AiFeedbackService {
    constructor(private http: HttpClient) {}

    saveAiUserFeedback(aiUserFeedbackParams: AiUserFeedbackParams): Observable<boolean> {
        const context = new HttpContext();
        context.set(IGNORE_CLIENT_LOADING, true);
        return this.http.post<boolean>(`/rest/ai/saveAiUserFeedback`, aiUserFeedbackParams, { context });
    }
}
